import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Checkbox,
  Tooltip
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
// include action file for add merchant
import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import DatePicker from "react-datepicker";
import moment from "moment";
import loader from "../../../style/loader/loader.scss";
import ReactHtmlParser from "react-html-parser";
import DateTimePicker from "react-datetime-picker";
import "../../../style/react-datetimepicker.scss";
import Clock from "./Clock";

const history = createBrowserHistory();

const HorizontalLine = ({}) => <hr />;

const propTypes = {};

let offerTitle = [],
  expirationMonth = [],
  expirationDate = [],
  minQuantity = [],
  skuCode = [],
  maxPerCustomer = [],
  maxAvailable = [],
  retailPrice = [],
  offerPrice = [],
  remittance = [],
  incrementalRedemption = [],
  maxAsGift = [];
let time = new Date().toLocaleString();

class DealAttribute extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isInfinite: 0,
      multi_lang: 'no',
    };
  }

  componentDidMount() {}

  isInfinite = e => {
    if (e.target.checked) {
      const indefiniteDate = moment().startOf('day').add(100, 'years').format("YYYY/MM/DD HH:mm:ss");
      this.setState({expiryDateTime : new Date(indefiniteDate), isInfinite: 1 });
      this.props.updateChildDeals(
        e.target.name,
        1,
        this.props.index, 
        [{field:'expiryDateTime', value:indefiniteDate}]
      );
    } else {
      const indefiniteDate = moment().startOf('day').format("YYYY/MM/DD HH:mm:ss");
      this.setState({expiryDateTime : new Date(indefiniteDate), isInfinite: 0 });
      this.props.updateChildDeals(
        e.target.name,
        0,
        this.props.index,
        [{field:'expiryDateTime', value:indefiniteDate}]
      );
    }
  };

  componentWillMount() {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));

    if(siteData){
      if(siteData.multi_lang){
        this.setState({
          multi_lang: siteData.multi_lang
        });
      }
    }
    const result1 = this.props.deal.startDateTime && this.props.deal.startDateTime.substring(0,10)
    const result2 = this.props.deal.expiryDateTime && this.props.deal.expiryDateTime.substring(0,10)
    this.setState({
      startDateTime: (this.props.deal.startDateTime != null && result1 != '1970-01-01' && this.props.deal.startDateTime != '')
        ? new Date(moment(this.props.deal.startDateTime).format("YYYY/MM/DD HH:mm:ss"))
        : "",
      expiryDateTime: (this.props.deal.expiryDateTime != null && result2 != '1970-01-01' && this.props.deal.expiryDateTime != '')
        ? new Date(moment(this.props.deal.expiryDateTime).format("YYYY/MM/DD HH:mm:ss"))
        : "",
      dealText: this.props.deal.dealText,
      french_dealText: this.props.deal.french_dealText,
      fontSize: this.props.deal.fontSize,
      voucherText: this.props.deal.voucherText,
      french_voucherText: this.props.deal.french_voucherText,
      isInfinite: this.props.deal.isInfinite,
      freeShipping:this.props.deal.freeShipping,
      shippingAmount: this.props.deal.shippingAmount,
      shippingAmountMerchant: this.props.deal.shippingAmountMerchant,
      shippingAmountAdmin: this.props.deal.shippingAmountAdmin,
      shipable: this.props.deal.freeShipping ? this.props.deal.freeShipping : this.state.shipable,
    });
  }

  handleChange = e => {
    this.props.updateChildDeals(
      e.target.name,
      e.target.value,
      this.props.index
    );
    this.setState({ [e.target.name]: e.target.value });
    if (e.target.name === "freeShipping") {
      if(e.target.value === "1") {
        this.setState({
          shippingAmountAdmin: 0,
          shippingAmountMerchant: 0,
          shippingAmount: 0,
          shipable: 1,
        });
      }else{
        this.setState({
          shipable: 0,
        });
      }
    }
  };
  
  handleShippingPercent = e => {
    let shippingAmountAdminConst,
      shippingAmountMerchantConst,
      sumOfPercent = 0.0;
    if (this.state.shippingAmountAdmin || this.state.shippingAmountMerchant) {
      shippingAmountAdminConst =
        this.state.shippingAmountAdmin !== 0 &&
        typeof this.state.shippingAmountMerchant !== "NaN"
          ? Number.parseFloat(this.state.shippingAmountAdmin)
          : 0;
      shippingAmountMerchantConst =
        this.state.shippingAmountMerchant !== 0 &&
        typeof this.state.shippingAmountMerchant !== "NaN"
          ? Number.parseFloat(this.state.shippingAmountMerchant)
          : 0;

      sumOfPercent = shippingAmountAdminConst + shippingAmountMerchantConst;
      if (sumOfPercent !== 100) {
        this.props.setDealAttributeError(e.target.name, this.props.index, false);
        this.setState({
          shippingAmountAdminError: "red",
          shippingAmountMerchantError: "red"
        });
        if (e.target.name === "shippingAmountMerchant") {
          this.setState({
            shippingAmountAdminTooltipError:
              "Sum of Merchant Shipping and Admin Shipping should be 100%"
          });
        } else if (e.target.name === "shippingAmountAdmin") {
          this.setState({
            shippingAmountAdminTooltipError:
              "Sum of Merchant Shipping and Admin Shipping should be 100%"
          });
        }
      } else if (sumOfPercent === 100) {
        this.props.setDealAttributeError(e.target.name, this.props.index, true);
        this.setState({
          shippingAmountMerchantTooltipError: "",
          shippingAmountAdminTooltipError: "",
          shippingAmountMerchantError: "",
          shippingAmountAdminError: ""
        });
      }
    }
  };

  componentWillReceiveProps(nextProps) {
    
  }

  onChangeStartDate = date => {
    this.setState({ startDateTime: date });
    this.props.updateChildDeals(
      "startDateTime",
      moment(date).format("YYYY-MM-DD HH:mm:ss"),
      this.props.index
    );
  };

  onChangeExpiryDate = date => {
    this.setState({ expiryDateTime: date });
    this.props.updateChildDeals(
      "expiryDateTime",
      moment(date).format("YYYY-MM-DD HH:mm:ss"),
      this.props.index
    );
  };

  render() {
    let isInfiniteChecked = this.props.deal.isInfinite == "1" ? "true" : "false";
    return (
      <div key={this.props.index} className={"dealAttribute-"+this.props.index} >
        <Col md={12} xs={12}>
          <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <Row className="bg-success">
              <Col md={2} xs={6} className="text-center">
                <ControlLabel>
                  <h5>Retail Price</h5>
                </ControlLabel>
                <h3>{localStorage.getItem('symbol')}{this.props.deal.retailPrice}</h3>
              </Col>
              <Col md={2} xs={6} className="text-center">
                <ControlLabel>
                  <h5>Offer Price</h5>
                </ControlLabel>
                <h3>{localStorage.getItem('symbol')}{this.props.deal.offerPrice}</h3>
              </Col>
              <Col md={2} xs={6} className="text-center">
                <ControlLabel>
                  <h5>Maximum Available</h5>
                </ControlLabel>
                <h3>{this.props.deal.maxAvailable}</h3>
              </Col>
              <Col md={2} xs={6} className="text-center">
                <ControlLabel>
                  <h5>Max Per Customer</h5>
                </ControlLabel>
                <h3>{this.props.deal.maxPerCustomer}</h3>
              </Col>
              <Col md={2} xs={6} className="text-center">
                <ControlLabel>
                  <h5>Max As Gift</h5>
                </ControlLabel>
                <h3>{this.props.deal.maxAsGift}</h3>
              </Col>
              <Col md={2} xs={6} className="text-center">
                <ControlLabel>
                  <h5>Expiration</h5>
                </ControlLabel>
                <h3>{this.props.deal.expiryDateTime ? moment(this.props.deal.expiryDateTime).format("YYYY/MM/DD HH:mm:ss") : this.props.deal.expiryDateTime}</h3>
              </Col>
            </Row>
          </div>
        </Col>
        <Col md={12} xs={12}>
          &nbsp;
        </Col>
        <Col md={12} xs={12}>
          <Row>
            <Col md={12} xs={12}>
              <ControlLabel>Duration</ControlLabel>
            </Col>
          </Row>
          
          <Row>
            <Col md={12} xs={12}>
              <Clock timezone={this.props.timezone} />
            </Col>
          </Row>
          <br />
          
          <Row>
            <Col md={3} xs={6}>
              {this.state.startDateTimeTooltipError && (
                <Tooltip placement="top" className="in" id="tooltip-top">
                  {this.state.startDateTimeTooltipError}
                </Tooltip>
              )}
              <DateTimePicker
                className={this.state.startDateTimeError}
                onChange={this.onChangeStartDate}
                value={this.state.startDateTime}
              />
            </Col>
            <Col md={1} xs={12}>
              <FormGroup controlId="formOfferTitle">
                <ControlLabel>until</ControlLabel>
              </FormGroup>
            </Col>
            <Col md={3} xs={6}>
              {this.state.expiryDateTimeTooltipError && (
                <Tooltip placement="top" className="in" id="tooltip-top">
                  {this.state.expiryDateTimeTooltipError}
                </Tooltip>
              )}
              <DateTimePicker
                onChange={this.onChangeExpiryDate}
                value={this.state.expiryDateTime}
              />
            </Col>
            <Col md={3} xs={12}>
              <FormGroup controlId="formInfinitely">
                {(this.props.deal.isInfinite == "1") ?
                <Checkbox
                  name="isInfinite"
                  defaultChecked={true}
                  onChange={this.isInfinite}
                >
                  Run this offer infinitely?
                </Checkbox>
                :
                <Checkbox
                  name="isInfinite"
                  onChange={this.isInfinite}
                >
                  Run this offer infinitely?
                </Checkbox>
                }
              </FormGroup>
            </Col>
          </Row>
        </Col>
        
        <Col md={12} xs={12}>
          <Row>
            <Col md={12} xs={12}>
              <ControlLabel>
                Offer Text (Text that appears on the site,
                up to 75 characters)
              </ControlLabel>
            </Col>
          </Row>
          <Row>
            <Col md={12} xs={12}>
              <FormGroup>
                <FormControl
                  type="text"
                  defaultValue={ReactHtmlParser(this.state.dealText)}
                  placeholder="Deal Text"
                  onBlur={this.handleChange}
                  name="dealText"
                />
                <p className="inline-validation-error">
                  {this.state.dealTextError !== ""
                    ? this.state.offerTitleError
                    : " "}
                </p>
              </FormGroup>
            </Col>
            {/*<Col md={1} xs={1} className="text-center">
              <FormGroup controlId="formAt">
                <ControlLabel>at</ControlLabel>
              </FormGroup>
            </Col>
            <Col md={2} xs={2}>
              <FormGroup>
                <FormControl
                  type="text"
                  defaultValue={this.state.fontSize}
                  placeholder="Font Size"
                  onBlur={this.handleChange}
                  name="fontSize"
                />
                <p className="inline-validation-error">
                  {this.state.fontSizeError !== ""
                    ? this.state.offerTitleError
                    : " "}
                </p>
              </FormGroup>
            </Col>
            <Col md={2} xs={2}>
              <FormGroup controlId="formPixels">
                <ControlLabel>pixels</ControlLabel>
              </FormGroup>
            </Col>*/}
          </Row>
          {(this.state.multi_lang == "yes") &&
          <Row>
            <Col md={12} xs={12}>
              <ControlLabel>
                Offer Text (Text that appears on the site,
                up to 75 characters in Canadian French)
              </ControlLabel>
            </Col>
          </Row>
          }
          {(this.state.multi_lang == "yes") &&
          <Row>
            <Col md={12} xs={12}>
              <FormGroup>
                <FormControl
                  type="text"
                  defaultValue={ReactHtmlParser(this.state.french_dealText)}
                  placeholder="Deal Text (Canadian French)"
                  onBlur={this.handleChange}
                  name="french_dealText"
                />
              </FormGroup>
            </Col>
          </Row>
          }
          <Row>
            <Col md={12} xs={12}>
              <FormGroup>
                <ControlLabel>
                  Voucher Text (Text that appears on the voucher)
                </ControlLabel>
                <FormControl
                  type="text"
                  defaultValue={this.state.voucherText}
                  placeholder="Voucher Text"
                  onBlur={this.handleChange}
                  name="voucherText"
                />
                <p className="inline-validation-error">
                  {this.state.voucherTextError !== ""
                    ? this.state.voucherTextError
                    : " "}
                </p>
              </FormGroup>
            </Col>
          </Row>
          {(this.state.multi_lang == "yes") &&
          <Row>
            <Col md={12} xs={12}>
              <FormGroup>
                <ControlLabel>
                  Voucher Text (Text that appears on the voucher in Canadian French)
                </ControlLabel>
                <FormControl
                  type="text"
                  defaultValue={this.state.french_voucherText}
                  placeholder="Voucher Text"
                  onBlur={this.handleChange}
                  name="french_voucherText"
                />
              </FormGroup>
            </Col>
          </Row>
          }

          {/**start redemption details **/}
            <Row>
              <header className="panel-heading" id={"ShippingOptions-"+this.props.index} >
                Shipping Options
              </header> 
              <div className="panel-body">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <Row>
                    <Col md={6} xs={12}>
                      <FormGroup>
                        <ControlLabel id={"freeShippingControlId-"+this.props.index} >Set Shipping Amount?</ControlLabel>
                        <FormControl
                          value={(this.state.freeShipping) ? this.state.freeShipping : ""}
                          onChange={this.handleChange}
                          componentClass="select"
                          name="freeShipping"
                          placeholder="select"
                        >
                          <option value="">Select</option>
                          <option value="0">No</option>
                          <option value="1">Yes</option>
                        </FormControl>
                      </FormGroup>
                    </Col>
                    <Col md={6} xs={12}>
                      {this.state.freeShipping == "1" ? (
                        <FormGroup>
                          <ControlLabel className="shippingAmountInput" id={"shippingAmountControlId-"+this.props.index} >
                            Shipping Amount
                          </ControlLabel>
                          <FormControl
                            type="number"
                            placeholder="Shipping Amount"
                            name="shippingAmount"
                            defaultValue={(this.state.shippingAmount) ? this.state.shippingAmount : ""}
                            onChange={this.handleChange}
                          />
                        </FormGroup>
                      ) : (
                        ""
                      )}
                    </Col>                 
                    <Col md={6} xs={12}>
                      {this.state.freeShipping == "1" ? (
                        <FormGroup >
                          <ControlLabel id={"shippingAmountMerchantControlId-"+this.props.index} className="shippingAmountMerchantControlId">
                            Merchant Shipping %
                          </ControlLabel>
                          <FormControl
                            type="number"
                            placeholder="Merchant Shipping %"
                            name="shippingAmountMerchant"
                            value={(this.state.shippingAmountMerchant) ? this.state.shippingAmountMerchant : ""}
                            onChange={this.handleChange}
                            onBlur={this.handleShippingPercent}
                            style={{
                              borderColor: this.state.shippingAmountMerchantError
                            }}
                          />
   
                        </FormGroup>
                      ) : (
                        ""
                      )}
                    </Col>
                    <Col md={6} xs={12}>
                      {this.state.freeShipping == "1" ? (
                        <FormGroup>
                          <ControlLabel id={"shippingAmountAdminControlId-"+this.props.index}>Admin Shipping %</ControlLabel>
                          <FormControl
                            type="number"
                            placeholder="Admin Shipping %"
                            name="shippingAmountAdmin"
                            value={(this.state.shippingAmountAdmin) ? this.state.shippingAmountAdmin : ""}
                            onChange={this.handleChange}
                            onBlur={this.handleShippingPercent}
                            style={{
                              borderColor: this.state.shippingAmountAdminError
                            }}
                          />
                          {this.state.shippingAmountAdminTooltipError && (
                            <Tooltip
                              placement="bottom"
                              className="in"
                              id="tooltip-top"
                              style={{ marginLeft: "386px", marginTop: "36px" }}
                            >
                              {this.state.shippingAmountAdminTooltipError}
                            </Tooltip>
                          )}
                        </FormGroup>
                      ) : (
                        ""
                      )}
                    </Col>
                  </Row>
                </div>
              </div>
            </Row>
          {/**end redemption detail **/}
        </Col>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {};
};

export default DealAttribute;



// WEBPACK FOOTER //
// ./src/app/views/admin/deal/DealAttribute.js